import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Container, Form, Typography } from 'amphitheatre';

import { FormWrapper, QOBLogo } from './Login.styled';
import { QFBButton } from '../Landing.styled';
import { Props } from './Login.types';
import Logo from './_img_logo.png';

import { rawURL } from '../../../index';

const { Header } = Typography;

function Landing({ loading, onLogin }: Props): React.ReactElement {
  return (
    <Container size="xs">
      <QOBLogo src={Logo} />
      <FormWrapper>
        <div style={{ padding: '1rem' }} />
        <Form onSubmit={onLogin}>
          <Header level={5} style={{ fontWeight: 'bold' }}>
            Login with your Saber Account
          </Header>
          <Form.Validator name="username" required>
            <Form.Input label="Username" />
          </Form.Validator>
          <Form.Validator name="password" type="password" required>
            <Form.Input label="Password" />
          </Form.Validator>
          <Form.Validator name="preserveToken">
            <Form.Checkbox label="Stay signed in?" />
          </Form.Validator>
          <Button type="submit" fill loading={loading}>
            Login
          </Button>
        </Form>
        <a
          href={`https://account.${rawURL}/register`}
          style={{ display: 'block', marginTop: '1rem' }}
          rel="noopener noreferrer"
          target="_blank"
        >
          <QFBButton disabled={loading}>Register For An Account</QFBButton>
        </a>
        <Link to="/about" style={{ display: 'block', marginTop: '1rem' }}>
          <Button fill ghost disabled={loading}>
            About Quest For Blue
          </Button>
        </Link>
        <Link to="/faq" style={{ display: 'block', marginTop: '1rem' }}>
          <Button fill ghost disabled={loading}>
            Frequently Asked Questions
          </Button>
        </Link>
      </FormWrapper>
    </Container>
  );
}

export default Landing;
